
import { Injectable } from '@angular/core';
import { ENV } from 'environments/environment';
import { CONSTANTS } from 'environments/common';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  constructor(private http: HttpClient) { }
  

  getFiraMaps(dataIn) {

    let url = ENV.APP.BACKEND_API + CONSTANTS.END_POINTS.MAPS.GET_FIRA_MAPS + dataIn.event + '/firamaps?exhibitorId=' + dataIn.id;

    return this.http.get(url, dataIn);
  }

}
